import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LibraryPage } from '@modules/report-generator/interfaces';

@Component({
  selector: 'app-page-detail',
  templateUrl: './page-detail.component.html',
  styleUrls: ['./page-detail.component.scss'],
})
export class PageDetailComponent {
  @Input() page!: LibraryPage;
  @Output() pageInsert = new EventEmitter<number>();
  @Output() back = new EventEmitter<void>();

  onInsert(): void {
    this.pageInsert.emit(this.page.id);
  }

  onBack(): void {
    this.back.emit();
  }

  getThumbnailAspectRatio(): string {
    return this.page.orientation === 'landscape' ? '842/595' : '595/842';
  }
}
